<template>
    <div class="issue-tracker__item hidden-sm-down" v-if="displayValue">
        <span class="issue-tracker__tag" :class="[getTagColor]">{{ displayValue }}</span>
    </div>
</template>

<script>
    import Base from '@/components/list_elements/Base'

    export default {
        extends: Base,

        computed: {
            getTagColor() {
                switch (this.value){
                    case 'Open':
                        return 'bg-light-blue'
                    case 'Closed':
                        return 'bg-gray'
                    case 'Wait For Response':
                        return 'bg-orange'
                    case 'In Progress':
                        return 'bg-light-green'
                    default:
                        return 'text-gray'
                }
            }
        }
    }
</script>

<style scoped>
    .issue-tracker__tag {
        padding: .3rem .75rem .4rem;
        line-height: 100%;
        font-size: .95rem;
        border-radius: 2px;
        color: #FFF;
    }
</style>